import { sanitizeHtml } from '@/utils/helpers/html';
// import { useMemo } from 'react';

interface ArticleContentProps {
    content: string;
    className?: string;
}


// function transformContentWithCaptions(html: string): string {
//     if (!html) return '';

//     const imgWithCaptionRegex = /<img([^>]*?)data-caption="([^"]+)"([^>]*?)>/gi;

//     return html.replace(imgWithCaptionRegex, (_match, before, caption, after) => {
//         const styleMatch = (before + after).match(/style="([^"]*)"/);
//         const existingStyle = styleMatch ? styleMatch[1] : '';

//         const cleanBefore = before.replace(/style="[^"]*"/g, '');
//         const cleanAfter = after.replace(/style="[^"]*"/g, '');

//         return `<figure class="image-with-caption my-4">
//       <img${cleanBefore}data-caption="${caption}"${cleanAfter} style="${existingStyle}" class="rounded-lg max-w-full h-auto" />
//       <figcaption class="text-sm text-gray-500 mt-2 italic">${caption}</figcaption>
//     </figure>`;
//     });
// }

export function ArticleContent({ content, className = '' }: ArticleContentProps) {
    // const transformedContent = useMemo(() => {
    //     return transformContentWithCaptions(content);
    // }, [content]);
const transformedContent = sanitizeHtml(content);
    return (
        <div
            className={`prose prose-lg max-w-none ${className}`}
            dangerouslySetInnerHTML={{ __html: transformedContent }}
        ></div>
    );
}

export default ArticleContent;

//    <div
//             className={`   [&_p]:mb-4
//     [&_p:last-child]:mb-0
//     [&_p:empty]:h-4 prose prose-lg max-w-none ${className}`}
//             dangerouslySetInnerHTML={{ __html: transformedContent }}
//         ></div>
